"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _PhoneCallPinLayout = require("./PhoneCallPinLayout");
Object.keys(_PhoneCallPinLayout).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _PhoneCallPinLayout[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _PhoneCallPinLayout[key];
    }
  });
});